import { LogLevel } from "@azure/msal-browser";
import { environment } from "../env";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

export const b2cPolicies = {
    authorities: {
        signUpSignIn: {
            authority: `https://${environment.AD_B2C_Tenant.split('.')[0]}.b2clogin.com/${environment.AD_B2C_Tenant}/${environment.AD_B2C_SignInPolicy}`,
        },
        forgotPassword: {
            authority: `https://${environment.AD_B2C_Tenant.split('.')[0]}.b2clogin.com/${environment.AD_B2C_Tenant}/${environment.AD_B2C_ResetPasswordPolicy}`,
        }
    },
    authorityDomain: `${environment.AD_B2C_Tenant.split('.')[0]}.b2clogin.com`,
};

export const msalConfig = {
    auth: {
        clientId: environment.AD_B2C_ApplicationId, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: environment.AD_B2C_ReactRedirectUri, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE || isEdge || isFirefox, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};